import RingSelect from './RingSelect';

export default RingSelect;
